'use client';

import { ArticleTagList as CommonArticleTagList } from '@monorepo/common';
import type { ArticleTagListProps } from '@monorepo/common';
import { useRouter } from 'next/navigation';

function ArticleTagList(props: ArticleTagListProps) {
  const router = useRouter();

  const handleTagClick = (tag: { id: number; name: string }) => {
    router.push(`/informations?tag=${tag.id}`);
  };

  return <CommonArticleTagList onTagClick={handleTagClick} {...props} />;
}

export default ArticleTagList;
